export class CreatePageCollabNoWorkspaceError extends Error {
	public readonly tag = "CreatePageCollabNoWorkspaceError";
	constructor(message?: string) {
		super(message ?? "Workspace name is required for collab documents");
		this.name = "CreatePageCollabNoWorkspaceError";
	}
}

export class CreatePageCollaDocumentMetadataError extends Error {
	public readonly tag = "CreatePageCollaDocumentMetadataError";
	constructor(documentId: string) {
		super(`collab object not found in document metadata for documentId: ${documentId}`);
		this.name = "CreatePageCollaDocumentMetadataError";
	}
}

export class CreatePageCollabNoRegistryConnectionError extends Error {
	public readonly tag = "CreatePageCollabNoRegistryConnectionError";
	constructor(workspaceName: string) {
		super(`No collab registry connection for workspace: ${workspaceName}`);
		this.name = "CreatePageCollabNoRegistryConnectionError";
	}
}

export class CreatePageUnsupportedPageTypeError extends Error {
	public readonly tag = "CreatePageUnsupportedPageTypeError";
	constructor(pageType: string) {
		super(`Unsupported page type: ${pageType}`);
		this.name = "CreatePageUnsupportedPageTypeError";
	}
}

export class CreatePageDocumentNotFoundError extends Error {
	public readonly tag = "CreatePageDocumentNotFoundError";
	constructor(documentId: string) {
		super(`Document not found: ${documentId}`);
		this.name = "CreatePageDocumentNotFoundError";
	}
}

export class CreatePageDirCollisionError extends Error {
	public readonly tag = "CreatePageDirCollisionError";
	constructor(targetDirRelative: string, fallbackDirRelative: string) {
		super(
			`Cannot create page directory: both '${targetDirRelative}' and '${fallbackDirRelative}' already exist`
		);
		this.name = "CreatePageDirCollisionError";
	}
}
